import * as React from 'react';

import type { CrewTypeFilterOption } from 'af-root/scenes/Company/FieldReports/WorkOrdersList/FullTable/Filters/CrewTypeFilter';
import type { JobFilterOption } from 'af-root/scenes/Company/FieldReports/WorkOrdersList/FullTable/Filters/JobFilter';
import type { ProjectManagerFilterOption } from 'af-root/scenes/Company/FieldReports/WorkOrdersList/FullTable/Filters/ProjectManagerFilter';
import type { SuperintendentFilterOption } from 'af-root/scenes/Company/FieldReports/WorkOrdersList/FullTable/Filters/SuperintendentFilter';

export type FieldReportFullViewFilterContextProps = {
	fieldReportFullViewFilterContext: FieldReportFullViewFilterContextType;
};

export interface FieldReportFullViewFilterContextType {

	crewTypeOptions: CrewTypeFilterOption[];
	jobOptions: JobFilterOption[];
	projectManagerOptions: ProjectManagerFilterOption[];
	superintendentOptions: SuperintendentFilterOption[];

	setCrewTypeOptions: (options: CrewTypeFilterOption[]) => void;
	setJobOptions: (options: JobFilterOption[]) => void;
	setProjectManagerOptions: (options: ProjectManagerFilterOption[]) => void;
	setSuperintendentOptions: (options: SuperintendentFilterOption[]) => void;

}

const defaultValue: FieldReportFullViewFilterContextType = {

	crewTypeOptions: [],
	jobOptions: [],
	projectManagerOptions: [],
	superintendentOptions: [],

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setCrewTypeOptions: (options: CrewTypeFilterOption[]) => { return; },
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setJobOptions: (options: JobFilterOption[]) => { return; },
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setProjectManagerOptions: (options: ProjectManagerFilterOption[]) => { return; },
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setSuperintendentOptions: (options: SuperintendentFilterOption[]) => { return; },
};

export const FieldReportFullViewFilterContext = React.createContext<FieldReportFullViewFilterContextType>(defaultValue);

export const FieldReportFullViewFilterContextProvider = ({ children }) => {

	const [crewTypeOptions, setCrewTypeOptions] = React.useState<CrewTypeFilterOption[]>(defaultValue.crewTypeOptions);
	const [jobOptions, setJobOptions] = React.useState<JobFilterOption[]>(defaultValue.jobOptions);
	const [projectManagerOptions, setProjectManagerOptions] = React.useState<ProjectManagerFilterOption[]>(defaultValue.projectManagerOptions);
	const [superintendentOptions, setSuperintendentOptions] = React.useState<SuperintendentFilterOption[]>(defaultValue.superintendentOptions);

	const setCrewTypeOptionsData = React.useCallback((options: CrewTypeFilterOption[]) => {
		setCrewTypeOptions(options);
	}, []);

	const setJobOptionsData = React.useCallback((options: JobFilterOption[]) => {
		setJobOptions(options);
	}, []);

	const setProjectManagerOptionsData = React.useCallback((options: ProjectManagerFilterOption[]) => {
		setProjectManagerOptions(options);
	}, []);

	const setSuperintendentOptionsData = React.useCallback((options: SuperintendentFilterOption[]) => {
		setSuperintendentOptions(options);
	}, []);

	const value: FieldReportFullViewFilterContextType = React.useMemo(() => ({
		crewTypeOptions,
		jobOptions,
		projectManagerOptions,
		superintendentOptions,
		setCrewTypeOptions: setCrewTypeOptionsData,
		setJobOptions: setJobOptionsData,
		setProjectManagerOptions: setProjectManagerOptionsData,
		setSuperintendentOptions: setSuperintendentOptionsData,
	}), [
		crewTypeOptions,
		jobOptions,
		projectManagerOptions,
		superintendentOptions,
		setCrewTypeOptionsData,
		setJobOptionsData,
		setProjectManagerOptionsData,
		setSuperintendentOptionsData,
	]);

	return (
		<FieldReportFullViewFilterContext.Provider value={value} >
			{children}
		</FieldReportFullViewFilterContext.Provider >
	);
};
